<div class="backpage-wrapper">
  <div class="ble-api-content-creator">
    <div class="ble-api-section">
      <div
        class="ble-api-container-1 padding s6 all"
        *ifPermissions="['API Support', 'Internal Admin']"
      >
        <div class="header">
          <h1>Schlage Mobile Bluetooth Credential API/SDK</h1>
        </div>
        <div class="search padding s6 all">
          <div
            class="inventory-main-title mat-title"
            *ifPermissions="['API Support', 'Internal Admin']"
          >
            {{ "Search.SelectCompany" | translate }}:
          </div>
          <form class="example-form" [formGroup]="form1">
            <mat-form-field
              class="example-full-width"
              appearance="outline"
              floatLabel="always"
            >
              <mat-label class="selectCo">{{
                "Search.Company" | translate
              }}</mat-label>
              <input
                type="text"
                placeholder="{{ 'Search.Placeholder' | translate }}"
                matInput
                formControlName="myControl"
                [matAutocomplete]="auto"
                [errorStateMatcher]="errorStateMatcher"
              />
              <mat-autocomplete
                autoActiveFirstOption
                #auto="matAutocomplete"
                mat-autoselect="true"
                [displayWith]="displayNameAPI.bind(this)"
                (optionSelected)="loadAPISummaryTechSupport($event)"
              >
                <mat-option
                  *ngFor="let option of filteredOptions | async"
                  [value]="option"
                >
                  {{ option.businessId }} (Account #{{
                    option.accountNumber || "N/A"
                  }}) <br />
                  {{ option.addressCity }}, {{ option.addressState }}
                </mat-option>
              </mat-autocomplete>
              <mat-error
                *ngIf="
                  (form1.controls['myControl'].dirty ||
                    form1.controls['myControl'].touched) &&
                  noResultsFound
                "
                >No results - Try again</mat-error
              >
            </mat-form-field>
          </form>
        </div>
      </div>
      <div
        class="ble-api-container padding s6 all"
        *ifPermissions="['API View']"
      >
        <div class="header">
          <h1>Schlage Mobile Bluetooth Credential API/SDK</h1>
        </div>
        <div class="inputs">
          <app-branch-inputs
            *ifPermissions="[
              'Engage View',
              'Engage Transfer',
              'API View',
              'Mobile Cred View',
              'Internal Admin'
            ]"
          ></app-branch-inputs>
        </div>
      </div>
    </div>
    <div class="ble-api-container padding s6 all">
      <div class="header">
        <h1>Integration Details</h1>
      </div>
      <div class="API-main API-landing-table-section">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z24">
          <!-- Integration Name Column -->
          <ng-container matColumnDef="integrationName">
            <th mat-header-cell *matHeaderCellDef>Integration Name</th>
            <td mat-cell *matCellDef="let element">
              {{ element.integrationName }}
            </td>
          </ng-container>

          <!-- Product Type Column -->
          <ng-container matColumnDef="productType">
            <th mat-header-cell *matHeaderCellDef>Product Type</th>
            <td mat-cell *matCellDef="let element">
              {{ element.productType }}
            </td>
          </ng-container>

          <!-- Total Active Credentials Column -->
          <ng-container matColumnDef="totalActiveCredentials">
            <th mat-header-cell *matHeaderCellDef>Total Active Credentials</th>
            <td mat-cell *matCellDef="let element">
              {{ element.totalActiveCredentials }}
            </td>
          </ng-container>

          <!-- Billing Anniversary Date Column -->
          <ng-container matColumnDef="billingAnniversaryDate">
            <th mat-header-cell *matHeaderCellDef>Billing Anniversary Date</th>
            <td mat-cell *matCellDef="let element">
              {{ datePipe.transform(element.anniversaryDate, "MM/dd/yyyy") }}
            </td>
          </ng-container>

          <ng-container matColumnDef="moreDetails">
            <th mat-header-cell *matHeaderCellDef>More Details</th>
            <td mat-cell *matCellDef="let element">
              <button mat-icon-button (click)="openAPIDetailsDialog(element)">
                <mat-icon class="flip-horizontal">more</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr
            mat-header-row
            class="custom-header-row"
            *matHeaderRowDef="displayedColumns"
          ></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
        <mat-paginator
          [pageSizeOptions]="[5, 10, 20]"
          showFirstLastButtons
          #paginator
        ></mat-paginator>
      </div>
    </div>
  </div>
</div>
